import React from 'react';
import { Box, Flex, useBreakpointValue, Spinner } from '@chakra-ui/react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import PrivateContentLayout from '../../Platform/Common/PrivateContentLayout';

import B2CStudentSideBar from '../Student/B2CStudentSideBar';

import axios from "axios";
import { useEffect, useMemo, useRef } from "react";

import { useStudentContext } from '../Student/B2CStudentContext';
import StudentContentLayout from '../Student/Layouts/StudentContentLayout';
import StudentFooterLayout from '../Student/Layouts/StudentFooter';
import { jwtDecode } from "jwt-decode";
import B2CPracticeSetDashboard from '../Student/Pages-Route-Level/B2CPracticeSetDashboard';
import B2CSectionPractice from '../Student/Pages-Route-Level/B2CSectionPractice';
import B2CStudentAttemptListings from '../Student/Pages-Route-Level/B2CStudentAttemptListings';
import PracticeAttemptDetailsViewer from '../Practice Assessment Engine/CommonPages/PracticeAttemptDetailsViewer';
import StudentAttemptInstructionStart from '../Practice Assessment Engine/StudentPages/StudentAttemptInstructionStart';
import B2COrdersPage from '../Student/Pages-Route-Level/B2COrdersPage';
import B2CProfilePage from '../Student/Pages-Route-Level/B2CProfilePage';
import B2CSupportPage from '../Student/Pages-Route-Level/B2CSupportPage';
import B2CMockExamsPage from '../Student/Pages-Route-Level/B2CMockExams';
import { StudentSidebarProvider } from "../Student/Layouts/StudentSidebarContext";


const B2CStudentRouter = () => {

  const {
    setStudentContext,
    setLoading,
    studentContext,
    loading,
  } = useStudentContext();


useEffect(() => {

  const loadStudentContext = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem("b2c_token");

      const apiurl = process.env.REACT_APP_API_URL;

      const response = await axios.get(
        `${apiurl}/b2c/student/context`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setStudentContext(response.data);

      console.log("Student Context", response.data);

    } catch (error) {

      console.error(
        "Failed to load student context",
        error
      );

    } finally {

      setLoading(false);
    }
  };

  loadStudentContext();



}, []);

  const isMobile = useBreakpointValue({ base: true, md: false });


  const token = localStorage.getItem("b2c_token");


    // ── Resolve the default "/" redirect target from context ──────────
  // Waits until context is loaded so we don't redirect to a wrong or
  // incomplete path during the async fetch window.
  const defaultRedirect = React.useMemo(() => {
    if (!studentContext) return null;

    const {
      last_active_entitlement_id,
      last_active_content_type,
      entitlements,
    } = studentContext;

    // Find the target entitlement -- prefer last active, fall back to first
    const targetEntitlement = last_active_entitlement_id
      ? entitlements.find(e => e.entitlement_id === last_active_entitlement_id)
      : entitlements[0];

    if (!targetEntitlement) return "/practice/app/support"; // no entitlements at all

    const contentType = last_active_content_type
      ?? targetEntitlement.current_content_type;

    if (contentType === "PRACTICE_SET" && targetEntitlement.practice_set) {
      return `/practice/app/entitlement/${targetEntitlement.entitlement_id}/practice-set/${targetEntitlement.practice_set.practice_set_id}/dashboard`;
    }

    // Phase 2: add BOOK routing here
    // if (contentType === "BOOK" && targetEntitlement.book) {
    //   return `/practice/app/book/${targetEntitlement.book.book_id}/dashboard`;
    // }

    // Fallback -- no known content type yet
    return "/practice/app/orders";

  }, [studentContext]);


const location = useLocation();
const scrollRef = useRef<HTMLDivElement>(null);

// Reset scroll on every pathname change
useEffect(() => {
  const el = scrollRef.current;
  if (!el) return;

  // Immediate reset (works for most cases)
  el.scrollTop = 0;

  // Optional: also force a second pass after layout settles
  // (helps when the new page has async content / images)
  const id = requestAnimationFrame(() => {
    el.scrollTop = 0;
  });

  return () => cancelAnimationFrame(id);
}, [location.pathname]);

// Prevent the browser from restoring old scroll positions
useEffect(() => {
  const prev = window.history.scrollRestoration;
  window.history.scrollRestoration = "manual";
  return () => {
    window.history.scrollRestoration = prev;
  };
}, []);

    return (
       <StudentSidebarProvider>
        <Box >
           {/* Sidebar with fixed width */}
                 {!isMobile && (
                    <B2CStudentSideBar />
                  )}
          <StudentContentLayout >
        
          {/* Main content area with flexible width */}
          <Box
              ref={scrollRef}
              overflowY="auto"
              h="100%"          // or flex="1" + minH={0} depending on your layout
              // important if parent uses flex
            >
            
            <Routes>
                          {/* ── Dynamic default route ── */}
            <Route
              path="/"
              element={
                loading || !defaultRedirect ? (
                  // Hold here while context loads -- prevents a flash
                  // redirect to the wrong place or a 404
                  <Box p={10} textAlign="center">
                    <Spinner size="lg" />
                  </Box>
                ) : (
                  <Navigate to={defaultRedirect} replace />
                )
              }
            />
              <Route path="/entitlement/:entitlement_id/practice-set/:practice_set_id/dashboard" element={<B2CPracticeSetDashboard />} />
              <Route path="/entitlement/:entitlement_id/practice-set/:practice_set_id/mock-exams" element={<B2CMockExamsPage />} />
              <Route path="/entitlement/:entitlement_id/practice-set/:practice_set_id/practice/:practice_set_section_id" element={<B2CSectionPractice />} />

              <Route path="/orders" element={<B2COrdersPage />} />
              <Route path="/profile" element={<B2CProfilePage />} />
              <Route path="/support" element={<B2CSupportPage />} />
              
             
              <Route
                path="/entitlement/:entitlement_id/practice-set/:practice_set_id/practice/:practice_set_section_id/question-set/:question_set_id/attempts"
                element={<B2CStudentAttemptListings />}
              />
              <Route
                path="/entitlement/:entitlement_id/practice-set/:practice_set_id/exam/:practice_set_exam_id/attempts"
                element={<B2CStudentAttemptListings />}
              />
              <Route
                path="/entitlement/:entitlement_id/practice-set/:practice_set_id/attempts"
                element={<B2CStudentAttemptListings />}
              />
              <Route path="/practice-attempt/:practice_attempt_id/view" element={<PracticeAttemptDetailsViewer />} />
              <Route path="/practice-attempt/attempt-instructions" element={<StudentAttemptInstructionStart />} />
            </Routes>
          </Box>
          </StudentContentLayout >
          <StudentFooterLayout/>
      </Box>
      </StudentSidebarProvider>
    );
  };

export default B2CStudentRouter;
